import Vue from 'vue';
import { keyBy, filter, head, difference } from 'lodash';
import types from './mutation-types';

const mutations = {
  [types.SET_CORE_CONCEPT_VIDEO_COURSES](state, coreConceptVideoCourses) {
    Vue.set(state, 'coreConceptVideoCourses', {
      ...state.coreConceptVideoCourses,
      ...difference(coreConceptVideoCourses, state.coreConceptVideoCourses),
    });
  },

  [types.SET_UNITS_WITH_CORE_CONCEPTS](state, units) {
    Vue.set(state, 'unitsWithCoreConcepts', {
      ...state.unitsWithCoreConcepts,
      ...difference(units, state.units),
    });
  },

  [types.SET_VIDEO_COURSES](state, courseList) {
    Vue.set(state, 'videoCourses', {
      ...state.videoCourses,
      ...keyBy(courseList, course => course.id),
    });
  },

  [types.REMOVE_VIDEO_COURSE](state, courseId) {
    const filtered = filter(state.videoCourses, course => (
      course.id !== courseId
    ));

    Vue.set(state, 'videoCourses', keyBy(filtered, course => course.id));
  },

  [types.SET_CORE_CONCEPT_VIDEO_COURSE](state, coreConceptVideoCourse) {
    Vue.set(state, 'coreConceptVideoCourse', coreConceptVideoCourse);
  },

  [types.FETCH_CORE_CONCEPT_VIDEO_COURSES](state, coreConceptVideoCourses) {
    Vue.set(state, 'coreConceptVideoCourse', head(coreConceptVideoCourses));
  },

  [types.UPDATE_CORE_CONCEPT_VIDEO_COURSE](state, coreConceptVideoCourse) {
    Vue.set(state, 'coreConceptVideoCourse', coreConceptVideoCourse);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/video-courses/store/mutations.js